import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const VOID_BG = '#080810';
const CARD_BG = '#0D0D1A';
const CYAN = '#00FFE5';
const ICE = '#E8F4FF';
const MUTED = '#8899AA';
const MONO = "'JetBrains Mono', 'Courier New', monospace";
const ORBITRON = "'Orbitron', monospace";

const SuccessModal = ({ isOpen, onClose, userEmail }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleContinue = () => {
    onClose();
    navigate('/user-login');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(8,8,16,0.85)', backdropFilter: 'blur(8px)' }}>
      <div onClick={onClose} className="absolute inset-0" />
      <div className="relative w-full max-w-md" style={{ background: CARD_BG, border: '1px solid rgba(0,255,229,0.4)', boxShadow: '0 0 40px rgba(0,255,229,0.1)' }}>
        <div className="p-6 text-center">
          <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(0,255,229,0.08)', border: '1px solid rgba(0,255,229,0.3)' }}>
            <Icon name="CheckCircle" size={28} style={{ color: CYAN }} />
          </div>
          <h2 style={{ fontFamily: ORBITRON, fontWeight: 700, fontSize: '1.2rem', color: ICE, marginBottom: '0.5rem' }}>
            ACCOUNT CREATED
          </h2>
          <p style={{ color: MUTED, fontSize: '0.78rem', fontFamily: MONO, marginBottom: '1.5rem', lineHeight: 1.7 }}>
            Account initialized. Verification dispatched to{' '}
            <span style={{ color: CYAN }}>{userEmail}</span>.
            Check your inbox to activate your access.
          </p>

          <div className="p-4 mb-6 text-left" style={{ background: 'rgba(0,255,229,0.04)', border: '1px solid rgba(0,255,229,0.15)' }}>
            <h3 style={{ fontFamily: MONO, fontWeight: 700, fontSize: '0.7rem', color: CYAN, marginBottom: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
              // NEXT STEPS
            </h3>
            <div className="space-y-2">
              {[
                'Verify your email address',
                'Complete your commander profile',
                'State your first mission',
              ]?.map((step, i) => (
                <div key={i} className="flex items-start space-x-3">
                  <span style={{ color: CYAN, fontFamily: MONO, fontSize: '0.7rem', fontWeight: 700, flexShrink: 0 }}>0{i + 1}.</span>
                  <p style={{ fontSize: '0.75rem', color: MUTED, fontFamily: MONO }}>{step}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-3">
            <button onClick={handleContinue}
              style={{ background: 'transparent', border: '1px solid #2DC896', color: '#2DC896', padding: '12px 24px', width: '100%', textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '13px', cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
              [ PROCEED TO AUTHENTICATION ]
            </button>
            <button onClick={onClose}
              className="w-full py-2 transition-all"
              style={{ background: 'transparent', border: '1px solid rgba(0,255,229,0.2)', color: MUTED, fontFamily: MONO, fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', cursor: 'pointer' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(0,255,229,0.5)'; e.currentTarget.style.color = ICE; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(0,255,229,0.2)'; e.currentTarget.style.color = MUTED; }}>
              VERIFY LATER
            </button>
          </div>

          <div className="mt-6 pt-4" style={{ borderTop: '1px solid rgba(0,255,229,0.15)' }}>
            <p style={{ fontSize: '0.65rem', color: MUTED, fontFamily: MONO }}>
              Didn't receive the email?{' '}
              <button style={{ color: CYAN, background: 'none', border: 'none', cursor: 'pointer', fontFamily: MONO, fontSize: '0.65rem', textTransform: 'uppercase' }}>
                RESEND VERIFICATION
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;